var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { OrganisationLogoExternalLink } from './organisation-logo-external-link';
import { useSite } from '../hooks/use-site';
import { ContentNode } from './content-node';
var cls = classNames('organisation-powered-by');
export var OrganisationPoweredByDefaultProps = {
  isInverted: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  "], ["\n    color: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  "])), theme.COLOR('text'))
});
var LabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    margin-right: ", ";\n    margin-bottom: ", ";\n  "], ["\n    font-size: ", ";\n    margin-right: ", ";\n    margin-bottom: ", ";\n  "])), theme.FONT_SIZE(14), theme.UNIT(8), theme.UNIT(1))
});
var LogoStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 140px;\n  "], ["\n    width: 140px;\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    a {\n      color: ", ";\n      font-weight: 500;\n    }\n  "], ["\n    a {\n      color: ", ";\n      font-weight: 500;\n    }\n  "])), theme.COLOR('strong'))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled.span.attrs(cls.attr('label'))(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Logo: styled(OrganisationLogoExternalLink)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  Content: styled(ContentNode)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var OrganisationPoweredBy = function (props) {
  var className = props.className,
    entity = props.entity,
    isInverted = props.isInverted;
  var _a = useSite(),
    poweredByLabel = _a.poweredByLabel,
    poweredByContent = _a.poweredByContent;
  var label = poweredByLabel || 'Powered By';
  var hasPoweredByContent = !!poweredByContent.text;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Label, null, label), hasPoweredByContent ? React.createElement(My.Content, {
    entity: poweredByContent
  }) : React.createElement(My.Logo, {
    entity: entity,
    isInverted: isInverted
  }));
};
OrganisationPoweredBy.defaultProps = OrganisationPoweredByDefaultProps;
OrganisationPoweredBy.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;